import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Trash } from "@phosphor-icons/react";
import { AttachmentUploader, AttachmentList } from "@/components/Attachments";

export default function Announcements() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", attachments: [] });
  const [open, setOpen] = useState(false);
  const canPost = ["admin", "hr", "gm"].includes(user?.role);
  const canDelete = ["admin", "hr", "gm"].includes(user?.role);

  const load = () => api.get("/announcements").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.title.trim()) return toast.error("Başlık gerekli");
    await api.post("/announcements", form);
    setForm({ title: "", body: "", attachments: [] }); setOpen(false); load();
    toast.success("Duyuru yayınlandı");
  };
  const del = async (id) => { await api.delete(`/announcements/${id}`); load(); };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-end flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Şirket İçi</div>
          <h1 className="font-display text-3xl font-bold mt-1">Duyurular</h1>
        </div>
        {canPost && (
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="new-ann-btn"><Plus size={16} className="mr-1" />Yeni Duyuru</Button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Yeni Duyuru</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div><Label>Başlık</Label><Input value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} data-testid="ann-title" /></div>
                <div><Label>İçerik</Label><Textarea rows={5} value={form.body} onChange={(e) => setForm({...form, body: e.target.value})} data-testid="ann-body" /></div>
                <div><Label>Ekler</Label><AttachmentUploader value={form.attachments} onChange={(atts) => setForm({...form, attachments: atts})} testId="ann-attach" /></div>
                <Button onClick={create} data-testid="ann-submit">Yayınla</Button>
              </div>
            </DialogContent>
          </Dialog>
        )}
      </div>
      <div className="space-y-3">
        {items.map((a) => (
          <Card key={a.id}>
            <CardContent className="p-6">
              <div className="flex justify-between items-start">
                <div>
                  <div className="font-display text-xl font-bold">{a.title}</div>
                  <div className="text-xs text-muted-foreground mt-1">{a.author} · {new Date(a.at).toLocaleString("tr-TR")}</div>
                  <div className="mt-3 whitespace-pre-wrap text-sm">{a.body}</div>
                  <AttachmentList attachments={a.attachments} testId={`ann-atts-${a.id}`} />
                </div>
                {canDelete && <Button size="icon" variant="ghost" onClick={() => del(a.id)}><Trash size={16} className="text-destructive" /></Button>}
              </div>
            </CardContent>
          </Card>
        ))}
        {items.length === 0 && <div className="text-muted-foreground">Duyuru yok</div>}
      </div>
    </div>
  );
}
